import { ColumnSettingsN } from "../models/column-settings.model";

export function syncColumnSettings(editColumnSettings: Partial<ColumnSettingsN>, defaultColumnSettings: Partial<ColumnSettingsN>)
{
    defaultColumnSettings.listViewSections.forEach(defaultSection => 
    {
        const correspondingSectionInEdit= editColumnSettings.listViewSections.find(editSection => editSection.name === defaultSection.name);
        if (correspondingSectionInEdit )
        {
            defaultSection.fields.forEach(defaultField => {
            const correspondingFieldInEdit  = correspondingSectionInEdit?.fields.find(editField => editField.columnName === defaultField.columnName);
            if (correspondingFieldInEdit  && correspondingFieldInEdit?.enabled){
            defaultField.enabled = true;
            }else{
            defaultField.enabled = false;
            }
            if (defaultField?.childFields?.length>0 && correspondingFieldInEdit?.childFields) {
                defaultField.childFields.forEach(defaultChildField =>{
                    const correspondingChildFieldInEdit = correspondingFieldInEdit?.childFields.find(editChildField => editChildField.columnName === defaultChildField.columnName);
                    if (correspondingChildFieldInEdit?.enabled){
                        defaultChildField.enabled = true;
                    } else {
                        defaultChildField.enabled = false;
                    }
                });
              }
            });            
        }
    });
    return defaultColumnSettings;

}
